export const ORIGINAL_SIZE = 'original'
export const POSTER_SIZE = 'w500'
